import React, { Component } from "react";

import Content from "../Components/Content";
import Header from "../Components/Header";


import { getTextForKey } from "../../../data/ct-api";
import t from "../../../helpers/t9n";
import { AppContext } from "../../../data/ContextProvider";

class Imprint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      isDisabledActive: true
    }
  }

  async componentDidMount() {
    try {
      const pageText = await getTextForKey("imprint")

      this.setState({
        pageText: pageText,
        loading: false,
      })
    } catch (error) {
      this.setState({
        pageText: "",
        loading: false,
      })
      console.log(error)
    }
  }

  handleCheckbox = (e) => {
    this.setState({ isDisabledActive: !this.state.isDisabledActive });
  };

  render() {
    if (this.state.loading) return t("global.loading");

    return (
      <div className="compl-tool">

        <Header headline="" />

        <div className="spacer"></div>

        <Content
          title={this.state.pageText.headline}
          text={this.state.pageText.body}
        />
      </div>

    )
  }
}

Imprint.contextType = AppContext;
export default Imprint;
